export const IRL_GATHERING_ROUTE = '/events/irl';
